import { QRCodeSVG } from "qrcode.react";
import { fmtDate } from "@/lib/helpers";

// Aperçu fidèle de l'étiquette 62 × 100 mm (Brother QL-820NWBc, DK-11202) — noir sur blanc
export default function PaletteLabelPreview({ palette, scale = 1 }) {
  const isDec = palette.type === "DECLASSEE";
  const qrUrl = `${window.location.origin}/p/${palette.code_qr}`;
  const motif = palette.motif === "Autre" && palette.motif_autre ? palette.motif_autre : palette.motif;

  return (
    <div
      data-testid="palette-label-preview"
      className="label-62x100 bg-white text-black relative overflow-hidden mx-auto"
      style={{
        width: "62mm", height: "100mm", padding: "2mm", boxSizing: "border-box",
        fontFamily: "'Barlow', 'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
        transform: `scale(${scale})`, transformOrigin: "top center",
        border: "1px solid #94a3b8",
      }}
    >
      <div
        className="relative w-full h-full flex flex-col"
        style={{ border: isDec ? "2mm solid #000" : "0.2mm solid #000" }}
      >
        {isDec && (
          <div className="bg-black text-white font-black text-center uppercase" style={{ fontSize: "11pt", padding: "1.5mm 0" }}>
            Palette déclassée
          </div>
        )}
        <div className="flex-1 flex flex-col" style={{ padding: isDec ? "2mm 3mm 1mm" : "2mm 2.5mm" }}>
          <div className="font-black uppercase" style={{ fontSize: "9.5pt", lineHeight: 1.1 }}>La Ferme d'Autheuil</div>
          <div className="whitespace-nowrap" style={{ fontSize: "6pt", lineHeight: 1.25 }}>LIOT Autheuil — Rue de la Haute Boulaye<br />27490 Autheuil-Authouillet</div>
          <div className="border-b border-black" style={{ margin: "1mm 0 1.5mm" }} />

          <KV label="Bâtiment" value={`${palette.batiment}  ·  ${palette.batiment_code}`} size="11pt" />
          <KV label="Date de ponte" value={fmtDate(palette.date_ponte)} size="11pt" />
          {isDec ? (
            <KV label="Motif" value={motif} size="9.5pt" />
          ) : (
            <KV label="Catégorie œufs" value={palette.categorie} size="10.5pt" />
          )}
          <div className="flex" style={{ gap: "6mm" }}>
            <KV label="Poids brut" value={`${palette.poids_brut.toFixed(1)} kg`} size="8.5pt" />
            <KV label="Tare" value={`${palette.tare.toFixed(1)} kg`} size="8.5pt" />
          </div>
          <div>
            <div className="uppercase" style={{ fontSize: "7pt", lineHeight: 1 }}>Poids net</div>
            <div className="font-black" style={{ fontSize: "18pt", lineHeight: 1.05 }}>{palette.poids_net.toFixed(1)} kg</div>
          </div>

          <div className="mt-auto flex items-end justify-between">
            <div style={{ paddingBottom: "0.5mm" }}>
              <div className="uppercase" style={{ fontSize: "7pt", lineHeight: 1 }}>N° Palette</div>
              <div className="font-black whitespace-nowrap" style={{ fontSize: "8.4pt", lineHeight: 1.2 }}>{palette.code_qr}</div>
              <div style={{ fontSize: "5.5pt" }}>Scanner le QR : traçabilité</div>
            </div>
            <QRCodeSVG value={qrUrl} level="M" style={{ width: "22mm", height: "22mm" }} />
          </div>
        </div>
        {isDec && (
          <div className="bg-black text-white font-black text-center uppercase" style={{ fontSize: "6.6pt", padding: "1.4mm 0" }}>
            Non destiné à la consommation directe
          </div>
        )}
      </div>
    </div>
  );
}

function KV({ label, value, size }) {
  return (
    <div style={{ marginBottom: "1.6mm" }}>
      <div className="uppercase" style={{ fontSize: "7pt", lineHeight: 1 }}>{label}</div>
      <div className="font-bold truncate" style={{ fontSize: size, lineHeight: 1.15 }}>{value}</div>
    </div>
  );
}
